__turbopack_context__.v({
  "loginWidget": "loginWidget-module-scss-module__1Tq5mG__loginWidget",
});
